//import CryptoJS from 'vue-cryptojs'
//var CryptoJS = require("vue-cryptojs");
import Vue from 'vue'

const SECRET_KEY = process.env.VUE_APP_CRYPTO_SECRET;

class CryptoJsService {
    hash(key) {
        return Vue.CryptoJS.SHA256(key, SECRET_KEY).toString();
    }

    encrypt(data) {
        if (data != null) {
            return Vue.CryptoJS.AES.encrypt(data, SECRET_KEY).toString();
        }
        return null;
    }

    decrypt(data) {
        if (data != null) {
            return Vue.CryptoJS.AES.decrypt(data, SECRET_KEY).toString(Vue.CryptoJS.enc.Utf8)
        }
        return null;
    }
}
export default new CryptoJsService();